import React from 'react';
import { getOriginalCounterPart } from 'react-multi-carousel/lib/utils';

/*
                ಠ_ಠ
https://github.com/YIZHUANG/react-multi-carousel/issues/49
https://github.com/YIZHUANG/react-multi-carousel/issues/

this thing was written by a madman
*/
// eslint-disable-next-line import/prefer-default-export
export const findOriginalChildIndex =
  (carouselRef: React.MutableRefObject<any>, carouselState: any, numChildren: number) => {
    if (!carouselRef.current) {
      return 0;
    }

    // yes i have to build this dictionary every time a slide changes
    // getOriginalCounterPart expects the current state of the carousel when invoked
    // no there isn't a better way to do this that i've found
    const children = React.Children.toArray(carouselRef.current.props.children);
    const dict = children.reduce((acc: any, _: any, idx: number) => {
      const clonedIndex = getOriginalCounterPart(
        idx,
        carouselState,
        React.Children.toArray(carouselRef.current.props.children),
      );
      acc[clonedIndex] = idx;
      return acc;
    }, {});

    return dict[carouselState.currentSlide] ?? numChildren - 1;
  };

export function mapListToCarousel<T>(list: Array<T>): { [key: number]: T } {
  let hash = {};

  for (let i = 2; i < list.length + 2; i += 1) {
    hash = {
      ...hash,
      ...{
        [i]: list[i - 2]
      }
    };
  }
  return hash;
}
